import { BetQLSportItem } from "./";

const MLBConfig: BetQLSportItem = {
  id: "38fd1b12-ff07-40ac-8fc2-2a9a90c00156",
  name: "MLB",
  url: "mlb",
  tabName: "MLB",
  icon: "baseball",
  imagePath: "MLB",
  key: "MLB",
  lookupKey: "mlb",
  favoriteLine: "moneyline",
  hasTeamPowerProjectionGrades: true,
  hasFGspreadPowerRating: true,
  hasFGmoneylinePowerRating: true,
  hasFGtotalPowerRating: true,
  has1HspreadPowerRating: false,
  has1HmoneylinePowerRating: true,
  has1HtotalPowerRating: true,
  has1PspreadPowerRating: false,
  has1PmoneylinePowerRating: false,
  has1PtotalPowerRating: false,
  hasPitchers: true,
  hasGoals: false,
  hasInjuries: true,
  hasNews: false,
  hasLineup: true,
  hasSchedule: true,
  hasConfiguredSchedule: false,
  hasTeamSummary: true,
  hasGameFilters: true,
  hasStadium: true,
  hasLocation: true,
  hasTeamRecord: true,
  hasApRank: false,
  hasConferenceDropdown: false,
  hasNewsInjuriesColumn: true,
  hasDraws: false,
  hasSharpData: true,
  hasTopTrendsData: true,
  hasPlayerProps: false,
  hasRecommendedBets: true,
  hasPopularEvents: true,
  isCollege: false,
  defaultUserSetting: '{"name": "Default Setting", "columnOrder": [33,2,5,9,14,4]}',
  defaultColumnOrder: [33, 2, 5, 9, 14, 4],
  publicThreshold: 60,
  sharpPercentThreshold: 30,
  sharpCountThreshold: 300,
  publicCountThreshold: 300,
  trendTypes: [
    { name: "Spread", key: "ats", url: "run-line-odds" },
    { name: "Moneyline", key: "ml", url: "moneyline-odds" },
  ],
  filters: [
    {
      name: "Moneyline",
      key: "moneyline",
      url: "moneyline-odds",
    },
    {
      name: "Run Line",
      key: "spread",
      url: "run-line-odds",
    },
    {
      name: "Total",
      key: "total",
      url: "totals-spread",
    },
    {
      name: "First 5 Inn",
      key: "1Hmoneyline",
      url: "first-five-innings-odds",
    },
    {
      name: "First 5 Inn O/U",
      key: "1Htotal",
      url: "first-five-innings-totals",
    },
  ],
  periods: ["FULLGAME", "FIRSTHALF", "SECONDHALF"],
  periodKeys: ["FG", "1H", "2H"],
  pickTypes: ["moneyline", "total", "spread", "F5moneyline", "F5total", "F5spread"],
};

export default MLBConfig;
